export const colors = {
    light: {
        background: {
            primary: 'oklch(100% 0 0)',
            secondary: 'oklch(98% 0.01 230)',
            tertiary: 'oklch(96% 0.01 230)',
            paper: 'oklch(100% 0 0)',
            elevated: 'oklch(100% 0 0)',
            inset: 'oklch(96% 0.01 230)'
        },
        primary: {
            50: 'oklch(97% 0.02 260)',
            100: 'oklch(94% 0.04 260)',
            200: 'oklch(90% 0.08 260)',
            300: 'oklch(82% 0.12 260)',
            400: 'oklch(70% 0.16 260)',
            500: 'oklch(60% 0.20 260)',
            600: 'oklch(52% 0.20 260)',
            700: 'oklch(45% 0.18 260)',
            800: 'oklch(38% 0.16 260)',
            900: 'oklch(30% 0.14 260)',
            contrast: 'oklch(100% 0 0)'
        },
        status: {
            new: 'oklch(70% 0.14 190)',        // Bright Cyan
            assigned: 'oklch(68% 0.10 310)',   // Soft Lavender
            in_progress: 'oklch(70% 0.16 260)',// Deep Blue/Violet
            pending: 'oklch(65% 0.05 260)',    // Muted Slate-Blue
            resolved: 'oklch(72% 0.12 150)',   // Clean Green
            closed: 'oklch(50% 0.02 260)',     // Dim Grey
        },
        accent: {
            50: 'oklch(97% 0.02 175)',
            100: 'oklch(94% 0.04 175)',
            200: 'oklch(88% 0.08 175)',
            300: 'oklch(80% 0.12 175)',
            400: 'oklch(72% 0.14 175)',
            500: 'oklch(65% 0.15 175)',
            600: 'oklch(55% 0.14 175)',
            700: 'oklch(48% 0.12 175)',
            800: 'oklch(42% 0.10 175)',
            900: 'oklch(35% 0.08 175)',
            contrast: 'oklch(100% 0 0)'
        },
        grey: {
            50: 'oklch(98% 0.01 230)',
            100: 'oklch(96% 0.01 230)',
            200: 'oklch(92% 0.01 230)',
            300: 'oklch(86% 0.01 230)',
            400: 'oklch(70% 0.01 230)',
            500: 'oklch(55% 0.01 230)',
            600: 'oklch(45% 0.01 230)',
            700: 'oklch(35% 0.01 230)',
            800: 'oklch(25% 0.01 230)',
            900: 'oklch(18% 0.01 230)',
        },
        success: {
            50: 'oklch(97% 0.03 150)',
            500: 'oklch(65% 0.18 150)',
            contrast: 'oklch(100% 0 0)'
        },
        warning: {
            50: 'oklch(97% 0.03 85)',
            500: 'oklch(80% 0.16 85)',
            contrast: 'oklch(20% 0 0)'
        },
        error: {
            50: 'oklch(97% 0.02 25)',
            500: 'oklch(62% 0.22 25)',
            contrast: 'oklch(100% 0 0)'
        },
        info: {
            50: 'oklch(97% 0.02 250)',
            500: 'oklch(60% 0.18 250)',
            contrast: 'oklch(100% 0 0)'
        },
        text: {
            primary: 'oklch(18% 0.01 230)',
            secondary: 'oklch(45% 0.01 230)',
            tertiary: 'oklch(48% 0.01 230)',
            muted: 'oklch(70% 0.01 230)',
            disabled: 'oklch(70% 0.01 230)',
            inverse: 'oklch(100% 0 0)',
            brandLight: 'oklch(45% 0.18 260)',
            brandMedium: 'oklch(52% 0.20 260)'
        },
        border: {
            light: 'oklch(92% 0.01 230)',
            main: 'oklch(86% 0.01 230)',
            strong: 'oklch(70% 0.01 230)',
            focus: 'oklch(60% 0.20 260)'
        },
        interactive: {
            hover: 'oklch(96% 0.01 230)',
            pressed: 'oklch(92% 0.01 230)',
            selected: 'oklch(97% 0.02 260)',
            selectedNeutral: 'oklch(0% 0 0 / 4%)',
            focus: 'oklch(60% 0.20 260 / 25%)'
        },
        ui: {
            iconDefault: 'oklch(55% 0.01 230)',
            iconActive: 'oklch(45% 0.01 230)',
            iconBrand: 'oklch(52% 0.20 260)',
            dotNeutral: 'oklch(86% 0.01 230)',
            dotActive: 'oklch(70% 0.01 230)',
        },
        chart: {
            primary: 'oklch(38% 0.16 260)',
            secondary: 'oklch(65% 0.18 200)',
            tertiary: 'oklch(65% 0.18 150)',
            quaternary: 'oklch(80% 0.16 85)',
            quinary: 'oklch(60% 0.22 291)',
            senary: 'oklch(65% 0.20 15)',
            grid: 'oklch(92% 0.01 230)',
            axis: 'oklch(55% 0.01 230)'
        }
    },

    dark: {
        background: {
            primary:   'oklch(17% 0.010 260)',  // blue-tinted dark — fresh, not pitch-black
            secondary: 'oklch(20% 0.012 260)',  // cards / sidebar
            tertiary:  'oklch(24% 0.015 260)',  // table headers / inset panels
            paper:     'oklch(21% 0.012 260)',  // modal / drawer surfaces
            elevated:  'oklch(28% 0.015 260)',  // hover targets / raised elements
            inset:     'oklch(13% 0.008 260)',  // deep-recessed inputs / code blocks
        },

        primary: {
            // Your Violet (#8B5CF6) centered at Hue 291
            50: 'oklch(97% 0.01 291)',
            100: 'oklch(92% 0.05 291)',
            200: 'oklch(86% 0.09 291)',
            300: 'oklch(80% 0.12 291)',
            400: 'oklch(70% 0.18 291)',
            500: 'oklch(60% 0.22 291)',
            600: 'oklch(52% 0.24 291)',
            700: 'oklch(45% 0.25 291)',
            800: 'oklch(38% 0.22 291)',
            900: 'oklch(30% 0.20 291)',
            text: 'oklch(80% 0.12 291)',      // Violet 300
            glow: 'oklch(60% 0.22 291 / 15%)', // Built-in alpha support!
            contrast: 'oklch(100% 0 0)'
        },
        status: {
            new: 'oklch(70% 0.14 190)',        // Bright Cyan
            assigned: 'oklch(68% 0.10 310)',   // Soft Lavender
            in_progress: 'oklch(70% 0.16 260)',// Deep Blue/Violet
            pending: 'oklch(65% 0.05 260)',    // Muted Slate-Blue
            resolved: 'oklch(72% 0.12 150)',   // Clean Green
            closed: 'oklch(50% 0.02 260)',     // Dim Grey
        },
        severity:{
            critical: 'oklch(70% 0.15 25)',  // Was 68% — now AAA on paper/tertiary, near-AAA on elevated
            high: 'oklch(68% 0.14 55)',      // Was 72% — now AAA everywhere
            medium: 'oklch(70% 0.12 85)',    // Unchanged — already AAA
            low: 'oklch(70% 0.12 150)',      // Was 74% — now AAA on elevated
        },
        // severity:{
        //     critical: 'oklch(75% 0.22 20)',  // Was 68% — now AAA on paper/tertiary, near-AAA on elevated
        //     high: 'oklch(76% 0.17 50)',      // Was 72% — now AAA everywhere
        //     medium: 'oklch(78% 0.15 75)',    // Unchanged — already AAA
        //     low: 'oklch(76% 0.15 160)',      // Was 74% — now AAA on elevated
        // },

        // SEMANTIC - Perceptually matched Lightness (approx 65% for 500s)
        success: {
            500: 'oklch(70% 0.17 150)',
            //500: 'oklch(80% 0.12 85)',
            text: 'oklch(85% 0.10 150)'
        },
        warning: {
            500: 'oklch(72% 0.15 50)',
            //500: 'oklch(75% 0.18 75)',
            //text: 'oklch(92% 0.12 85)'
            text: 'oklch(80% 0.12 85)'
        },
        error: {
            //500: 'oklch(62% 0.22 25)',
            500: 'oklch(68% 0.16 25)',
            600: 'oklch(0.6000 0.230 70.67)',
            700: 'oklch(80% 0.16 85)',
            text: 'oklch(82% 0.12 25)'
        },
        info: {
            //500:'oklch(0.7742 0.0912 217.62) TODO keep in mind as an alternative for when all colors will be reassessed
            500: 'oklch(70% 0.16 260)',
            //500: 'oklch(65% 0.18 250)',
            text: 'oklch(85% 0.10 250)'
        },

        text: {
            primary:   'oklch(97% 0.005 250)',  // near-white, minimal cool tint
            secondary: 'oklch(82% 0.008 250)',  // soft gray — readable, not harsh
            tertiary:  'oklch(66% 0.008 250)',  // muted metadata
            disabled:  'oklch(48% 0.006 250)',
            brand:     'oklch(80% 0.12 291)',   // Violet 300 — unchanged
        },

        border: {
            light:  'oklch(100% 0 0 / 7%)',   // white/7% — slightly softer than before
            main:   'oklch(30% 0.010 260)',    // blue-tinted border
            strong: 'oklch(38% 0.010 260)',    // stronger separator
            focus:  'oklch(70% 0.18 291)',     // Violet focus — unchanged
        },

        interactive: {
            hover:    'oklch(28% 0.015 260)',  // matches background.elevated
            selected: 'oklch(26% 0.012 260)',  // subtle lift for active nav items
        },

    }
} as const;

export const colorUtils = {
    // Relative Color Syntax: Lightens any OKLCH color by 10%
    hover: (color: string) => `oklch(from ${color} calc(l + 0.1) c h)`,

    getFocusStyle: (theme: 'light' | 'dark') => ({
        outline: `2px solid ${colors[theme].border.focus}`,
        outlineOffset: '2px',
    }),

    // Simplifies opacity management
    withOpacity: (color: string, opacity: number) => `${color.replace(')', ` / ${opacity * 100}%)`)}`,
};